import React, { useContext, useState } from 'react';
import AddEmoticon from '@wix/da-ds/pkg/Icons/24x24/AddEmoticon';
import { ButtonProps } from './types';
import { getExternalRenderer, isExtensionInstalled } from '../../utils/tiptap';
import EditorIconButton from '../../menus/_partials/EditorIconButton';
import { useTranslation } from 'react-i18next';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
import type { OffsetModifier } from '@wix/da-ds/pkg/popper/types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ModalRoot from '@wix/da-ds/pkg/modals/base/ModalRoot';

const offsetModifier: OffsetModifier = [0, 6];

const Reaction: React.FC<ButtonProps> = ({
  editor,
  hideWhenNotEnabled = true,
}) => {
  const { t } = useTranslation('editor');
  const [open, setOpen] = useState(false);
  const isMobile = useContext(MobileContext);

  if (
    !editor.isEditable ||
    (hideWhenNotEnabled && !isExtensionInstalled(editor, 'emote'))
  ) {
    return null;
  }

  const EmotePicker = getExternalRenderer(editor, 'emoteSelector');

  const button = (
    <EditorIconButton
      featureId="node:emote"
      icon={AddEmoticon}
      onClick={() => {
        setOpen(!open);
      }}
      tooltipText={t('button.emote')}
      aria-label={t('button.emote')}
    />
  );

  const content = (
    <EmotePicker
      onRequestClose={() => {
        setOpen(false);
      }}
      onSelect={(type: 'emote' | 'emoji', item) => {
        switch (type) {
          case 'emoji':
            editor.chain().focus().setEmoji(item.unicode).run();
            break;
          case 'emote':
            switch (item.type) {
              case 'official':
                editor.chain().focus().setEmote(item.title).run();
                break;
              case 'community':
                editor.chain().focus().setCommunityEmote(item).run();
                break;
              case 'user':
                editor.chain().focus().setAvatar(item).run();
                break;
              default:
            }
            break;
          default:
        }
      }}
    />
  );

  if (isMobile) {
    return (
      <>
        {button}
        <ModalRoot
          isOpen={open}
          hasCloseButton={false}
          shouldCloseOnOverlayClick
          onRequestClose={() => {
            setOpen(false);
          }}
        >
          {content}
        </ModalRoot>
      </>
    );
  }

  return (
    <PositionOnlyPopperPopover
      popoverContent={content}
      placement="top"
      isVisible={open}
      offsetModifier={offsetModifier}
      onClickOutside={() => {
        setOpen(false);
      }}
    >
      {button}
    </PositionOnlyPopperPopover>
  );
};
Reaction.displayName = 'Reaction';

export default Reaction;
